// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"heading-section_wrapper__PeMxD","heading":"heading-section_heading__fQlgd","text":"heading-section_text__zzVbr","demoContent":"heading-section_demoContent__yCcCA"};